import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";

export interface TipoMaterial {
  id: number;
  descricao?: string | null;
}

/** Finalidade do Produto (cad_material). */
export function useTiposMaterial() {
  const { data: tiposMaterial = [], isLoading } = useQuery({
    queryKey: ["tipos-material"],
    queryFn: async () => (await apiClient.get<TipoMaterial[]>("/api/tipos-material")).data,
    staleTime: 10 * 60 * 1000,
  });
  return { tiposMaterial, isLoading };
}
